export const InsertDots = (name: string,count:number) => {
    if (!name) return "";
    return name?.slice(0, count) + (name?.length > count ? "..." : "");
};

export default InsertDots;
